import { useEffect } from 'react';
import { useEvent } from '@/hooks/useEvent';

type WindowEventCallback<Type extends string> = (
  event: Type extends keyof WindowEventMap ? WindowEventMap[Type] : Event
) => void;

export function useWindowEvent<Type extends string>(
  type: Type,
  cb: WindowEventCallback<Type>,
  options?: AddEventListenerOptions | boolean
): void {
  const eventCb = useEvent(cb as (event: Event) => void);

  useEffect(() => {
    window.addEventListener(type, eventCb, options);
    return () => window.removeEventListener(type, eventCb, options);
  }, [type, eventCb, options]);
}
